// extracted by mini-css-extract-plugin
export var cancelButton = "_qd-5";
export var content = "_qd-3";
export var createButton = "_qd-6";
export var drawerContainer = "_qd-0";
export var footer = "_qd-2";
export var header = "_qd-1";
export var orderFormColumn = "_qd-4";